<ng-container *transloco="let t">
  <div
    class="content-padding"
    [class.unsaved]="!dashboard?.locked && dashboardUnsaved"
    [class.bulk-editing]="selectModeStore.mode()"
  >
    <div class="content-header-fixed">
      @if (dashboard) {
        <div
          class="dashboard-view__title-bar"
          [class.dashboard-view__title-bar-centered]="isSharedSession"
        >
          @if (!isSharedSession) {
            <div class="dashboard-view__back-to-project-wrapper">
              <a
                [routerLink]="[projectRoute]"
                class="dashboard-view__back-to-project kxi-text-600 kxi-text-small"
              >
                <xi-icon icon="arrow_left" color="CX"></xi-icon
                >{{ t('dashboard-view.label.back-to-project', { projectName: project.name }) }}
              </a>
            </div>
          }
          <div
            class="dashboard-view__dashboard-title-wrapper"
            [ngClass]="showEdit ? 'dashboard-view__dashboard-title-wrapper--edit' : ''"
          >
            @if (!showEdit) {
              <h1 class="dashboard-view__dashboard-title" [matTooltip]="dashboard.title">
                {{ dashboard.title | truncate: 30 }}
              </h1>
            }
          </div>
          @if (!isSharedSession) {
            <div>
              @if (canShareDashboard()) {
                <xi-icon-button
                  [disabled]="!dashboard.payload.isExecutive || selectModeStore.isActive()"
                  icon="share"
                  color="CX"
                  [tooltip]="shareButtonTooltip()"
                  buttonSize="large"
                  (onClick)="shareDashboard()"
                >
                </xi-icon-button>
              }
              <xi-icon-button
                icon="settings"
                color="CX"
                buttonSize="large"
                (onClick)="showDashboardOptions = true"
                [disabled]="selectModeStore.isActive() || isDashboardNew"
                [tooltip]="settingsButtonTooltip()"
              >
              </xi-icon-button>
              @if (!isReadOnly && !dashboard.locked && !isDashboardNew) {
                <xi-icon-button
                  icon="trash"
                  color="CX"
                  buttonSize="large"
                  [disabled]="selectModeStore.isActive()"
                  [tooltip]="deleteButtonTooltip()"
                  (onClick)="deleteDashboard()"
                >
                </xi-icon-button>
              }
            </div>
          }
        </div>
      }
    </div>

    <div class="dashboard-tab-bar" [class.isLocked]="dashboard?.locked">
      <div class="pages-tab-container">
        <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
        <nav mat-tab-nav-bar [disableRipple]="true" [stretchTabs]="true" [tabPanel]="tabPanel">
          @for (page of dashboardPages; track page.id) {
            <a
              mat-tab-link
              [disabled]="selectModeStore.isActive()"
              [active]="page.id === currentPageTabId"
              (click)="onCurrentPageChanged(page.id)"
            >
              {{ page.title | truncate: 25 }} {{ isPageUnsaved(page.id) ? '*' : '' }}
              @if (page.id === currentPageTabId && !(isReadOnly || isExecutiveUser)) {
                <button
                  class="page-menu-trigger"
                  [matMenuTriggerFor]="pageMenuTrigger"
                  #pageMenuTriggerElement="matMenuTrigger"
                  (click)="$event.stopPropagation()"
                >
                  <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-cancel"></mat-icon>
                </button>
              }
            </a>
          }
        </nav>
        @if (!isReadOnly && !isExecutiveUser && !selectModeStore.mode()) {
          <xi-icon-button
            icon="add_circle"
            [disabled]="!canAddPage()"
            [tooltip]="{
              text: !canAddPage()
                ? t('dashboard-view.tooltip.cannot-add-page')
                : t('dashboard-view.tooltip.add-new-page'),
            }"
            (onClick)="addPage()"
          ></xi-icon-button>
        }
      </div>

      @if (dashboard && !selectModeStore.mode()) {
        <div class="dashboard-tab-actions">
          @if (isAnyWidgetDirty) {
            <div>
              <xi-icon-button
                icon="refresh"
                color="CX"
                [tooltip]="{ text: t('dashboard-view.tooltip.data-source-modified') }"
                (onClick)="refreshDirtyWidgets()"
              ></xi-icon-button>
            </div>
          }
          @if (isAnyWidgetDatasourceRemoved) {
            <div>
              <xi-icon-button
                icon="warning"
                color="warning"
                [tooltip]="{ text: t('dashboard-view.tooltip.data-source-removed') }"
              ></xi-icon-button>
            </div>
          }
          <xi-default-button
            iconLeft="clock_2"
            text="{{ t('dashboard-view.label.timezone-offset', { timezoneName: timezoneOffset }) }}"
            fill="text"
            [disabled]="dashboard.locked"
            [tooltip]="{ text: timezoneTooltip, direction: 6 }"
            (onClick)="changeTimezone()"
          >
          </xi-default-button>
        </div>
      }
    </div>

    <div
      #elementDashboardWrapper
      class="dashboardWrapper content fit scroll"
      tourAnchor="tour-dashboard-page"
      [ngClass]="{
        invisible: isLoading.dashboard || currentPageWidgets.length === 0,
        selectMode: selectModeStore.isActive(),
      }"
    >
      @if (showSavedViewBanner && activeSavedView) {
        <div class="dashboard-details__saved-view-banner">
          <div class="dashboard-details__saved-view-banner-left">
            <xi-icon-button icon="cancel" (onClick)="savedViewBannerClose.emit()"></xi-icon-button>
            <span class="kxi-text-normal kxi-txt-400" [matTooltip]="activeSavedView?.name">
              <ng-container *appMiddleEllipsize="activeSavedView?.name"></ng-container>
            </span>
            @if (activeSavedView?.hasUnsavedChanges) {
              <span class="dashboard-details__saved-view-banner-edited kxi-text-small kxi-txt-400">
                {{ t('dashboard-details-component.saved-views-banner.edited') }}
              </span>
            }
          </div>
          <div class="dashboard-details__saved-view-banner-actions">
            <xi-default-button
              text="{{ t('dashboard-details-component.saved-views-banner.save-as') }}"
              fill="outline"
              buttonSize="small"
              (onClick)="savedViewBannerSaveAs.emit()"
            ></xi-default-button>
            <xi-default-button
              fill="outline"
              buttonSize="small"
              text="{{ t('dashboard-details-component.saved-views-banner.save') }}"
              [disabled]="!activeSavedView?.hasUnsavedChanges"
              (onClick)="savedViewBannerSave.emit()"
            ></xi-default-button>
            <xi-default-button
              text="{{ t('dashboard-details-component.saved-views-banner.revert') }}"
              fill="text"
              buttonSize="small"
              [disabled]="!activeSavedView?.hasUnsavedChanges"
              (onClick)="savedViewBannerRevert.emit()"
            ></xi-default-button>
          </div>
        </div>
      }
      <div class="dashboard-activity-bar" #actionBarContainer>
        <div class="pill-container">
          @if (!isLoading.dashboard) {
            <app-dashboard-pill-wrapper
              [disabled]="dashboard?.locked || isReadOnly || selectModeStore.isActive()"
              [isReadOnly]="isReadOnly"
              [dashboardId]="dashboardId"
              [dashboard]="dashboard"
              [currentPageId]="currentPageId"
              [currentWidgets]="currentPageWidgets"
              [activityParent]="elementDashboardWrapper"
              [containerParent]="actionBarContainer"
              [widgetAddBtn]="widgetAddBtnRef?.nativeElement"
              (onActivitybarInteraction)="onActivitybarInteraction.emit($event)"
            ></app-dashboard-pill-wrapper>
          }
        </div>

        @if (!isReadOnly) {
          <div
            #widgetAddBtn
            [matTooltip]="!canAddWidget ? t('dashboard-view.tooltip.cannot-add-widget') : ''"
            class="dashboard-view__add-widget-wrapper"
          >
            <xi-default-button
              [disabled]="!canAddWidget || dashboard?.locked || !!selectModeStore.mode()"
              [text]="t('dashboard-view.label.add-widget')"
              (onClick)="onAddWidget()"
            ></xi-default-button>
          </div>
        }
      </div>

      @if (dashboard) {
        <gridster
          #elementDashboard
          [options]="dashboardOptions"
          [ngClass]="{
            'no-scroll': isExpansionPanelShowing,
          }"
        >
          @for (widget of currentPageWidgets; track widget) {
            <gridster-item
              #gridsterItem
              [item]="widget"
              class="widget-container"
              [ngClass]="{
                'selection-state':
                  selectModeStore.selected().length &&
                  selectModeStore.selected()[0].id === widget.id,
                sortable: customSortMode.enabled && customSortMode.widget === widget.id,
              }"
            >
              @if (currentPageWidgetsShowing) {
                <app-widget
                  #elementWidget
                  [dashboard]="dashboard"
                  [dashboardOptions]="dashboardOptions"
                  [widget]="widget"
                  [isReadOnly]="isReadOnly"
                  [canAddWidget]="canAddWidget"
                  [detailsHidden]="arePageWidgetDetailsHidden"
                  [widgetGroup]="widgetGroupStore.getByWidget(widget.id)"
                  [comparisonList]="comparisonList"
                  [comparison]="dashboard.comparisons[widget.payload.comparison]"
                  [dataSource]="datasourceManagerStore.getById(widget.dataSourceId)"
                  [hasChanges]="changedWidgets.has(widget.id)"
                  [hasSmartSummaryResources]="hasSmartSummaryResources"
                  [project]="project"
                  (addWidget)="onAddWidget($event)"
                  (cloneWidget)="onCloneWidget($event.widget, $event.pageId)"
                  (moveWidget)="onMoveWidget($event.widget, $event.pageId)"
                  (deleteWidget)="onDeleteWidget($event)"
                  (widgetLoading)="onWidgetLoading($event, widget.id)"
                  (widgetLoaded)="onWidgetLoaded($event, widget.id)"
                  (isCustomSortModeChange)="
                    onCustomSortModeChanged($event, widget.id, gridsterItem)
                  "
                  (syncItemColors)="onSyncItemColors($event)"
                  (resetItemColor)="onResetItemColor($event)"
                  (updateWidgetGroupMembership)="onUpdateWidgetGroupMembership($event)"
                  (addDateFilterToWidgetGroup)="onAddWidgetGroupDateFilter($event)"
                  (updateWidgetGroupParent)="onUpdateWidgetGroupParent($event)"
                  (openApplyComparison)="onOpenApplyComparison($event)"
                  (openCreateDriverAnalysis)="onOpenCreateDriverAnalysis($event)"
                  (onActivitybarInteraction)="onActivitybarInteraction.emit($event)"
                  (ignoreWidgetChange)="ignoreWidgetChange($event)"
                  (beforeExpansionPanelOpen)="onBeforeExpansionPanelOpen($event)"
                ></app-widget>
              }
            </gridster-item>
          }
        </gridster>
      }
    </div>

    @if (isLoading.dashboard) {
      <div class="dashboardWrapper loading xi-loader-container__center">
        <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
      </div>
    }
    @if (!isLoading.dashboard && currentPageWidgets.length === 0) {
      <div class="dashboardWrapper">
        @if (isReadOnly) {
          <div class="dashboard-view__dashboard-welcome-wrapper">
            <div class="dashboard-view__dashboard-welcome">
              <h3 class="kxi-text-600">{{ t('dashboard-view.text.no-widgets') }}</h3>
              <p class="kxi-text-normal kxi-text-center">
                {{ t('dashboard-view.text.contact-owner') }}
              </p>
            </div>
          </div>
        } @else {
          <div class="dashboard-view__dashboard-welcome-wrapper">
            <div class="dashboard-view__dashboard-welcome">
              <div class="dashboard-view__dashboard-welcome-icon">
                <xi-svg svg="celebration"></xi-svg>
              </div>
              <h1 class="kxi-text-600 dashboard-view__dashboard-welcome-title">
                {{ t('dashboard-view.text.welcome') }}
              </h1>
              @if (canAddWidget) {
                <div class="dashboard-view__dashboard-welcome-content">
                  <p>{{ t('dashboard-view.text.things-to-know') }}:</p>
                  <ul class="kxi-text-normal dashboard-view__dashboard-welcome-list">
                    <li><div [innerHTML]="t('dashboard-view.text.filter-segment-drill')"></div></li>
                    <li><div [innerHTML]="t('dashboard-view.text.move-resize-edit')"></div></li>
                    <li>{{ t('dashboard-view.text.save-your-dashboard') }}</li>
                  </ul>
                  <p>
                    <b class="kxi-text-600 kxi-text-normal">{{
                      t('dashboard-view.text.have-fun')
                    }}</b>
                  </p>
                  <div class="dashboard-view__add-widget-button-container">
                    <xi-default-button
                      text="{{ t('dashboard-view.label.add-widget') }}"
                      buttonSize="large"
                      [stretch]="true"
                      [disabled]="dashboard?.locked"
                      (onClick)="onAddWidget()"
                    ></xi-default-button>
                  </div>
                </div>
              } @else {
                <div>
                  <p class="kxi-text-normal kxi-text-center">
                    {{ t('dashboard-view.text.no-data-source') }}
                  </p>
                  <p class="kxi-text-normal kxi-text-center">
                    {{ t('dashboard-view.text.please-add-data') }}
                  </p>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>

  @if (dashboard && selectModeStore.mode()) {
    <div class="dashboard-view__bulk-action-bar">
      <div class="dashboard-view__bulk-action-bar-buttons">
        @if (selectModeStore.mode() !== 'edit') {
          <span>{{
            t('dashboard-view.text.selected', { numberSelected: selectModeStore.selectedCount() })
          }}</span>
        }
        <xi-default-button
          class="dashboard-view__filter_mode_buttons"
          text="{{ t('dashboard-view.label.cancel') }}"
          fill="text"
          (onClick)="cancelSelect(true)"
        ></xi-default-button>
        @if (selectModeStore.selectedCount() !== availableWidgetsCount()) {
          <xi-default-button
            class="dashboard-view__filter_mode_buttons"
            text="{{ t('dashboard-view.label.select-all') }}"
            fill="outline"
            (onClick)="selectAllWidget()"
          ></xi-default-button>
        }
        @if (
          selectModeStore.selectedCount() === availableWidgetsCount() && availableWidgetsCount() > 0
        ) {
          <xi-default-button
            class="dashboard-view__filter_mode_buttons"
            text="{{ t('dashboard-view.label.select-none') }}"
            fill="outline"
            (onClick)="unselectAllWidget()"
          ></xi-default-button>
        }
        @if (selectModeStore.mode() === 'edit') {
          <xi-default-button
            class="dashboard-view__filter_mode_buttons"
            text="{{ t('dashboard-view.label.undo') }}"
            fill="outline"
            [disabled]="editModeHistoryPointer === 0"
            (onClick)="undoEditStep()"
          ></xi-default-button>
        }
        @if (selectModeStore.mode() === 'edit') {
          <xi-default-button
            class="dashboard-view__filter_mode_buttons"
            text="{{ t('dashboard-view.label.redo') }}"
            fill="outline"
            [disabled]="editModeHistoryPointer === editModeHistory.length - 1"
            (onClick)="redoEditStep()"
          ></xi-default-button>
        }
        <!-- Manual layout action: auto arrange widgets in row-major order -->
        @if (selectModeStore.mode() === 'edit') {
          <xi-default-button
            class="dashboard-view__filter_mode_buttons"
            text="{{ t('dashboard-view.label.auto-layout') }}"
            fill="outline"
            (onClick)="onAutoArrangeClick()"
          ></xi-default-button>
        }
        <xi-default-button
          class="dashboard-view__filter_mode_buttons"
          [text]="applySelectModeButtonText"
          [disabled]="selectModeStore.mode() === 'filters' && !selectModeStore.hasSelection()"
          (onClick)="applySelectedWidgets()"
        ></xi-default-button>
      </div>
    </div>
  }

  <mat-menu #pageMenuTrigger class="menu-with-xi-icons">
    <button mat-menu-item (click)="onPageRenameOpened()">
      <xi-icon icon="edit_text"></xi-icon>
      <div>{{ t('dashboard-view.label.rename') }}</div>
    </button>

    <div [matTooltip]="!canAddPage() ? t('dashboard-view.tooltip.cannot-add-page') : undefined">
      @if (!isCurrentPageSpecial) {
        <button mat-menu-item (click)="clonePage()" [disabled]="!canAddPage()">
          <xi-icon icon="copy"></xi-icon>
          <div>{{ t('dashboard-view.label.clone-page') }}</div>
        </button>
      }
    </div>

    @if (!isReadOnly) {
      <div>
        <button mat-menu-item (click)="enterEditMode()">
          <xi-icon icon="exchange"></xi-icon>
          <div>{{ t('dashboard-view.label.edit-page-layout') }}</div>
        </button>
        <button mat-menu-item [disabled]="canReorderPage()" (click)="showPageReorderModal = true">
          <xi-icon icon="document_multiple"></xi-icon>
          <div>{{ t('dashboard-view.label.reorder-pages') }}</div>
        </button>
      </div>
    }

    <div>
      <button mat-menu-item (click)="togglePageDetailsVisibility()">
        <xi-icon [icon]="arePageWidgetDetailsHidden ? 'visibility' : 'visibility_off'"></xi-icon>
        <div>
          {{
            arePageWidgetDetailsHidden
              ? t('dashboard-view.label.show-details')
              : t('dashboard-view.label.hide-details')
          }}
        </div>
      </button>
    </div>

    <button mat-menu-item (click)="downloadDashboardPage(currentPageId)">
      <xi-icon icon="download"></xi-icon>
      <div>{{ t('dashboard-view.label.download-powerpoint') }}</div>
    </button>

    @if (!isCurrentPageSpecial) {
      <div [matTooltip]="deletePageTooltip">
        <button
          mat-menu-item
          (click)="onPageDeleteOpened()"
          [disabled]="dashboard?.payload.pages.length === 1"
        >
          <xi-icon icon="trash"></xi-icon>
          <div>{{ t('dashboard-view.label.delete-page') }}</div>
        </button>
      </div>
    }
  </mat-menu>

  @if (showPageReorderModal) {
    <app-lex-xi-modal
      [isVisible]="showPageReorderModal"
      maxWidth="600px"
      (close)="onPageReorderClosed('')"
    >
      <ng-template appXIModalContent>
        @if (showPageReorderModal) {
          <app-dashboard-page-reorder-dialog
            [pages]="dashboard.payload.pages"
            (modalClosed)="onPageReorderClosed($event)"
          ></app-dashboard-page-reorder-dialog>
        }
      </ng-template>
    </app-lex-xi-modal>
  }
  @if (showPageRenameModal) {
    <app-lex-xi-modal
      [isVisible]="showPageRenameModal"
      maxWidth="600px"
      (close)="onPageRenameClosed('')"
    >
      <ng-template appXIModalContent>
        @if (showPageRenameModal) {
          <app-dashboard-page-rename-dialog
            [options]="pageRenameOptions"
            (modalClosed)="onPageRenameClosed($event)"
          ></app-dashboard-page-rename-dialog>
        }
      </ng-template>
    </app-lex-xi-modal>
  }
  @if (customSortMode.enabled) {
    <div class="dashboard-view__custom-sort-overlay"></div>
  }
  @if (showDashboardOptions) {
    <app-dashboard-options
      [open]="showDashboardOptions"
      [session]="session"
      [dashboard]="dashboard"
      [isReadOnly]="isReadOnly"
      [isHideVisible]="isAdmin || isOwner"
      (close)="onDashboardOptionsClosed()"
      (saveDashboard)="onDashboardOptionsSave($event)"
      (clearUserCache)="clearUserCache()"
      (saveAsDashboard)="saveAsDashboard()"
      (exportDashboard)="exportDashboard()"
      (restoreDashboard)="restoreDashboard($event)"
    ></app-dashboard-options>
  }
  @if (showApplyComparisonModal) {
    <app-lex-xi-modal
      [isVisible]="showApplyComparisonModal"
      (close)="onApplyComparisonModalClosed(null)"
    >
      <ng-template appXIModalContent>
        @if (showApplyComparisonModal) {
          <app-apply-comparison-dialog
            [widgetComponent]="applyComparisonModalData.widgetComponent"
            [dashboard]="dashboard"
            (modalClosed)="onApplyComparisonModalClosed($event)"
          ></app-apply-comparison-dialog>
        }
      </ng-template>
    </app-lex-xi-modal>
  }

  <!--Timezone Modal-->
  @if (showTimezoneModal) {
    <app-lex-xi-modal
      [isVisible]="showTimezoneModal"
      maxWidth="500px"
      (close)="onTimezoneModalClosed('')"
    >
      <ng-template appXIModalContent>
        @if (showTimezoneModal) {
          <app-account-change-timezone
            [options]="{
              currentValue: dashboardTimezone,
              defaultValue: timezoneService.defaultTimezone,
            }"
            (modalClosed)="onTimezoneModalClosed($event)"
          ></app-account-change-timezone>
        }
      </ng-template>
    </app-lex-xi-modal>
  }

  <!-- Widget Create Modal -->
  @if (showWidgetAddDialog) {
    <app-lex-xi-modal
      [isVisible]="showWidgetAddDialog"
      maxWidth="1200px"
      (close)="onWidgetAddDialogClosed(null)"
    >
      <ng-template appXIModalContent>
        @if (showWidgetAddDialog) {
          <app-widget-add-dialog
            [data]="widgetAddDialogData"
            (modalClosed)="onWidgetAddDialogClosed($event)"
          ></app-widget-add-dialog>
        }
      </ng-template>
    </app-lex-xi-modal>
  }

  <app-project-collection-actions
    #collectionActions
    [project]="{ id: projectId }"
  ></app-project-collection-actions>
</ng-container>

@if (showRatingFieldSelectorModal) {
  <app-lex-xi-modal
    [isVisible]="showRatingFieldSelectorModal"
    [canBackdropClose]="false"
    [maxWidth]="ratingModalWidth"
    (close)="showRatingFieldSelectorModal = false"
  >
    <ng-template appXIModalContent>
      <app-rating-field-selector-dialog
        [data]="ratingFieldSelectorData"
        [title]="ratingTitle"
        (modalClosed)="showRatingFieldSelectorModal = false"
        (widthChange)="handleMaxWidthChange($event)"
      ></app-rating-field-selector-dialog>
    </ng-template>
  </app-lex-xi-modal>
}

<!-- Save As - New Dashboard Modal -->
@if (showNewDashboardModal) {
  <app-lex-xi-modal
    [isVisible]="showNewDashboardModal"
    maxWidth="660px"
    (close)="onNewDashboardModalClosed(null)"
  >
    <ng-template appXIModalContent>
      <app-new-dashboard
        [data]="newDashboardModalData"
        (modalClosed)="onNewDashboardModalClosed($event)"
      ></app-new-dashboard>
    </ng-template>
  </app-lex-xi-modal>
}
@if (showGridAnalyticItemSelectorDialog) {
  <app-lex-xi-modal
    [isVisible]="showGridAnalyticItemSelectorDialog"
    [canBackdropClose]="false"
    maxWidth="950px"
    (close)="onCloseGridAnalyticItemSelectorDialog(ModalCloseType.CLOSE)"
  >
    <ng-template appXIModalContent>
      @if (showGridAnalyticItemSelectorDialog) {
        <app-grid-analytic-item-selector-dialog
          [options]="gridAnalyticItemSelectorDialogOptions"
          (close)="onCloseGridAnalyticItemSelectorDialog($event)"
        >
        </app-grid-analytic-item-selector-dialog>
      }
    </ng-template>
  </app-lex-xi-modal>
}
@if (showJourneyAnalyticItemSelectorDialog) {
  <app-lex-xi-modal
    [isVisible]="showJourneyAnalyticItemSelectorDialog"
    [canBackdropClose]="false"
    maxWidth="1200px"
    (close)="onCloseJourneyAnalyticItemSelectorDialog(ModalCloseType.CLOSE)"
  >
    <ng-template appXIModalContent>
      @if (showJourneyAnalyticItemSelectorDialog) {
        <app-journey-analytic-item-selector-dialog
          [options]="journeyAnalyticItemSelectorDialogOptions"
          (close)="onCloseJourneyAnalyticItemSelectorDialog($event)"
        >
        </app-journey-analytic-item-selector-dialog>
      }
    </ng-template>
  </app-lex-xi-modal>
}
@if (isExpansionPanelShowing) {
  <div class="widget-expansion-panel-overlay" (click)="onExpansionPanelOverlayClicked()"></div>
}
@if (showAnalyticItemModal) {
  <app-lex-xi-modal
    [isVisible]="showAnalyticItemModal"
    [canBackdropClose]="false"
    maxWidth="900px"
    (close)="showAnalyticItemModal = false"
  >
    <ng-template appXIModalContent>
      <app-widget-analytic-item-dialog
        [options]="analyticItemModalOptions"
        (modalClosed)="showAnalyticItemModal = false"
      >
      </app-widget-analytic-item-dialog>
    </ng-template>
  </app-lex-xi-modal>
}
